module.exports = __webpack_public_path__ + "static/media/photo276.f3f26c8c.jpg";